import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { VersionService } from './version.service';
import { ToastOptions, ToastService } from './toast.service';

@Injectable({
    providedIn: 'root',
})
export class VersionMismatchDetectionService {
    private apiVersion: string;
    newVersionToastOptions: ToastOptions;

    constructor(private versionService: VersionService, private toast: ToastService) {
        this.newVersionToastOptions = {
            actionText: 'REFRESH',
            logic: 'refresh',
            timeout: 0,
            dismiss: true,
        };
    }

    pollForNewWebVersion() {
        if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
            return;
        }
        interval(120000)
            .pipe(
                startWith(0),
                switchMap(() => this.versionService.getAppVersion())
            )
            .subscribe((apiVersion) => {
                if (!this.apiVersion) {
                    this.apiVersion = apiVersion.toString();
                } else if (apiVersion.toString() !== this.apiVersion) {
                    this.apiVersion = apiVersion.toString();
                    this.toast.info(
                        'A new version of nCino Mortgage Analytics is now available.',
                        this.newVersionToastOptions
                    );
                }
            });
    }
}
